import Star from '@mui/icons-material/Star';
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt';
import { Button, CircularProgress, Dialog, DialogActions, DialogTitle, Paper, Tooltip } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../../ReactComponent';

class IconeDestaque extends ReactComponent {
    abrirDialog = false;
    destaques = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirDialog: observable,
            destaques: observable,
            registro: computed,
            handleCloseDialog: action,
            handleClickStar: action,
            carregarDestaques: action,
            carregarConteudoDestaques: action,
            carregarConteudoDestaque: action,
            baixarConteudoRtfDestaque: action,
            existeDestaque: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    handleCloseDialog = () => {
        this.abrirDialog = false;
    };

    handleClickStar = () => {
        this.destaques = [];
        this.registro.contabilizacoesObservacao.forEach((observacao) => {
            if (observacao.tipoObservacao === 'DESTAQUE' && observacao.visibilidade === 'PUBLICA') {
                this.carregarDestaques(observacao.siglaMagistrado);
            }
        });
    };

    carregarDestaques = async (siglaMagistrado) => {
        let destaques = await this.sessaoService.recuperarDestaques(
            this.registro.sessaoId,
            this.registro.numeroProcesso,
            siglaMagistrado
        );
        this.carregarConteudoDestaques(destaques);
    };

    carregarConteudoDestaques = async (destaques) => {
        destaques.forEach(async (destaque) => {
            if (destaque.tipoConteudo === 'RTF') {
                await this.baixarConteudoRtfDestaque(destaque);
            } else {
                this.abrirDialog = true;
                await this.carregarConteudoDestaque(destaque);
                runInAction(() => {
                    this.destaques.push({
                        id: destaque.id,
                        autor: destaque.magistrado.sigla,
                        conteudo: destaque.conteudo
                    });
                });
            }
        });
    };

    carregarConteudoDestaque = async (destaque) => {
        let conteudoDestaque = await this.sessaoService.recuperarConteudoDestaque(
            this.registro.sessaoId,
            this.registro.numeroProcesso,
            destaque.magistrado.sigla,
            destaque.id
        );
        destaque.conteudo = conteudoDestaque.conteudo;
    };

    baixarConteudoRtfDestaque = async (destaque) => {
        let mimeType = 'application/rtf';
        let conteudo = await this.sessaoService.recuperarConteudoRtfDestaque(
            this.registro.sessaoId,
            this.registro.numeroProcesso,
            destaque.magistrado.sigla,
            destaque.id
        );

        let tempLink = document.createElement('a');
        document.body.appendChild(tempLink);
        tempLink.href = URL.createObjectURL(new Blob([conteudo], { type: mimeType }));
        tempLink.download = 'destaque-' + destaque.magistrado.sigla + '-' + this.registro.numeroProcesso + '.rtf';
        tempLink.click();
        document.body.removeChild(tempLink);
    };

    get existeDestaque() {
        return this.salaSessaoStore.possuiDestaque(this.registro);
    }

    render() {
        if (!this.existeDestaque) {
            return null;
        }

        return (
            <div style={{ margin: '3px', display: 'flex', alignItems: 'center' }}>
                <Tooltip title={'Manifestações (Destaques)'}>
                    <Star
                        onClick={this.handleClickStar}
                        style={{ cursor: 'pointer', fillOpacity: '0.4' }}
                    />
                </Tooltip>
                {this.abrirDialog && (
                    <Dialog
                        onClose={this.handleCloseDialog}
                        open={this.abrirDialog}
                        maxWidth={false}
                    >
                        <DialogTitle
                            id="simple-dialog-title"
                            style={{ paddingBottom: '0px' }}
                        >
                            {'Manifestações (Destaques) do ' + this.registro.processo.numeroCompleto}
                        </DialogTitle>
                        {this.destaques.length > 0 ? (
                            <div
                                style={{
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    justifyContent: 'center',
                                    margin: '0px 10px',
                                    overflowX: 'auto'
                                }}
                            >
                                {this.destaques.map((destaque) => {
                                    return (
                                        <Paper
                                            key={this.nextKey}
                                            elevation={10}
                                            style={{ display: 'flex', flexDirection: 'column', margin: '10px' }}
                                        >
                                            <div style={{ margin: '10px' }}>
                                                <h4 style={{ margin: '10px 0px' }}>{destaque.autor}</h4>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: destaque.conteudo }}
                                                    style={{
                                                        overflowX: 'auto',
                                                        minWidth: '300px',
                                                        maxWidth: '640px',
                                                        minHeight: '60px',
                                                        maxHeight: '200px'
                                                    }}
                                                />
                                            </div>
                                        </Paper>
                                    );
                                })}
                            </div>
                        ) : (
                            <CircularProgress
                                style={{ margin: '15px' }}
                                size={30}
                                disableShrink={true}
                            />
                        )}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="primary"
                                variant="contained"
                                endIcon={<ThumbUpAlt />}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </div>
        );
    }
}

export default inject('stores')(observer(IconeDestaque));
